import { render, staticRenderFns } from "./DownloadMediaBlock.vue?vue&type=template&id=61a563fe&"
import script from "./DownloadMediaBlock.vue?vue&type=script&lang=js&"
export * from "./DownloadMediaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports